import React from "react";

type IconProps = React.SVGProps<SVGSVGElement>;

const PermitIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.75 1.66663C14.2102 1.66663 14.5833 2.03972 14.5833 2.49996C14.5833 2.9602 14.2102 3.33329 13.75 3.33329H4.58333C4.3519 3.33329 4.16667 3.51853 4.16667 3.74996V15.8333C4.16667 16.2897 4.54357 16.6666 5 16.6666H14.1667C14.6231 16.6666 15 16.2897 15 15.8333V14.1666C15 13.7064 15.3731 13.3333 15.8333 13.3333C16.2936 13.3333 16.6667 13.7064 16.6667 14.1666V15.8333C16.6667 17.2102 15.5436 18.3333 14.1667 18.3333H5C3.6231 18.3333 2.5 17.2102 2.5 15.8333V3.74996C2.5 2.59806 3.43143 1.66663 4.58333 1.66663H13.75Z"
        fill="#1A1A1A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7435 5.4622C14.3938 4.81201 15.4465 4.81232 16.097 5.4622L17.4219 6.78788C18.0723 7.43832 18.0723 8.49096 17.4219 9.1414L12.4642 14.0991C12.2533 14.3099 11.9867 14.4631 11.6919 14.5345L11.6927 14.5353L8.5848 15.31C8.30105 15.3807 8.00057 15.2979 7.79378 15.0911C7.58711 14.8843 7.50331 14.5838 7.57406 14.3001L8.34961 11.1922C8.41766 10.9038 8.56464 10.6338 8.78581 10.4207L13.7435 5.4622ZM9.96582 11.5966L9.52718 13.3569L11.2866 12.9183L16.241 7.96383L14.9202 6.64303L9.96582 11.5966Z"
        fill="#1A1A1A"
      />
      <path
        d="M7.5 8.33329C7.96024 8.33329 8.33333 8.70639 8.33333 9.16663C8.33333 9.62686 7.96024 9.99996 7.5 9.99996H6.25C5.78976 9.99996 5.41667 9.62686 5.41667 9.16663C5.41667 8.70639 5.78976 8.33329 6.25 8.33329H7.5Z"
        fill="#1A1A1A"
      />
      <path
        d="M9.58333 4.99996C10.0436 4.99996 10.4167 5.37306 10.4167 5.83329C10.4167 6.29353 10.0436 6.66663 9.58333 6.66663H6.25C5.78976 6.66663 5.41667 6.29353 5.41667 5.83329C5.41667 5.37306 5.78976 4.99996 6.25 4.99996H9.58333Z"
        fill="#1A1A1A"
      />
    </svg>
  );
};

export default PermitIcon;
